import NoteDetail from "../AdjustmentNotes/NoteDetail";
import "./debitDesign.css";
export default function DebitNoteDetail() {
  return <NoteDetail />;
}
